import React, { useState, useEffect } from 'react';
import { connect } from "react-redux";
import { GetUsers, ClearUsers } from '../../store/actions/userActions'; 
import { TextInput } from 'react-materialize';
import { Button, Modal, Table, Input } from 'antd';
import { Redirect } from 'react-router-dom';
import { TextField } from '@material-ui/core';
import validator from 'validator';

const { Search } = Input;

function UserList(props) {
    const [searchUser, setSearch]      = useState("");
    const [isLoading, setLoading]      = useState(true);
    const [isCreating, setCreating]    = useState(false);
    const [modalView, setModalView]    = useState(false);
    const [redirectId, setRedirectID]  = useState("");

    // useEffect(() => {
    //     const unsubscribe = async () => {
    //         return props.GetUsers();
    //     };
    //     setLoading(false);
    //     unsubscribe();
    //     let unsub = unsubscribe;
    //     return async () => {
    //         unsub();
    //     };
    // },[]);
 
    useEffect(() => {
        const unsubscribe = async () => {
            await props.ClearUsers();
            return await props.GetUsers();
        }
        let unsub = unsubscribe();
        return async () => {
            let unsubU = await unsub; 
            unsubU();
        };
    },[]);

    let user = [];
    if(searchUser) {
        let search = searchUser.toLowerCase();
        user = props.users.filter(user => 
            (user.name && user.name.toLowerCase().includes(search)) ||
            (user.phone && user.phone.toLowerCase().includes(search))
        );
    } else {
        user = props.users;
    }

    user = user.sort((a,b) => {
        let user_a = a.name ? a.name.toUpperCase() : "";
        let user_b = b.name ? b.name.toUpperCase() : "";
        let comparison = 0;
        if (user_a > user_b) {
            comparison = 1;
        } else if (user_a < user_b) {
            comparison = -1;
        }
        return comparison;
    });

    const columns = [
        {
            title: 'Phone',
            dataIndex: 'phone',
            render: (phone) => formatPhoneNumber(phone),
            width: '25%',
        },
        {
            title: 'Name',
            dataIndex: 'name',
            width: '30%',
        },        
        {
            title: 'ID',
            dataIndex: 'id',
            width: '45%',
        }
    ];


    if (redirectId !== "") {
        return <Redirect push to={`/admin/user/${redirectId}`} />;
    }

    //Render
    return (
        <div className="container">
            <div className="col s12">
                <Table
                    title={() => 
                        <div style={{display: "flex", justifyContent: "space-between", alignItems: "center"}}>
                            <div style={{display: "flex", justifyContent: "space-around", alignItems: "baseline"}}>
                            <h2 style={{marginBottom: "0"}}>User List</h2>
                            </div>
                            <Search
                                placeholder="Search"
                                enterButton="Search"
                                size="large"
                                onSearch={value => setSearch(value)}
                                style={{ width: 335 }}
                            />
                        </div>
                    }
                    columns={columns}
                    rowKey={user => user.id}
                    dataSource={user}
                    loading={user.length <= 0}
                    pagination={{ pageSize: 12 }}
                    onRow={(record, rowIndex) => {
                        return {
                            onClick: e => setRedirectID(record.id), // click row
                        };
                    }}
                />
            </div>
        </div>
    );
}

const mapStateToProps = (state) => {
    return {
        auth:       state.firebase.auth,
        users:      state.user.users,
    }
}

// const mapStateToProps = ({ firebase: { auth, profile } }) => ({
//     auth,
//     profile
// });

const mapDispatchToProps = (dispatch) => {
    return {
      GetUsers:     () => dispatch(GetUsers()),
      ClearUsers:   () => dispatch(ClearUsers()),
    }
}

function formatPhoneNumber(phoneNumberString) {
    var cleaned = ('' + phoneNumberString).replace(/\D/g, '')
    var match = cleaned.match(/^(\d{3})(\d{3})(\d{4})$/)
    if (match) {
      return '(' + match[1] + ') ' + match[2] + '-' + match[3]
    }
    return null
  }

export default connect(mapStateToProps, mapDispatchToProps)(UserList);
